/**
 * 移除背景 API
 * 走自有后端 /web/v1/removeBg 接口
 * 提交任务后通过 removeBgQuery 轮询结果
 */
import apiClient from './config'

/**
 * 提交移除背景任务
 * @param {File} file - 图片文件
 * @returns {Promise<string>} 返回 create_id
 */
export function submitRemoveBg(file) {
  var formData = new FormData()
  formData.append('file', file)

  return apiClient
    .post('removeBg', formData, {
      timeout: 120000,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(function(res) {
      var data = res.data || res
      var createId = data.create_id || data.createId || data.task_id || data.taskId
      if (createId) {
        return createId
      }
      // 兼容旧接口：如果直接返回了图片 URL，作为同步结果返回
      if (data.image || data.image_url || data.url) {
        return { sync: true, url: data.image || data.image_url || data.url }
      }
      throw new Error(res.message || '移除背景提交失败')
    })
}

/**
 * 轮询移除背景任务结果
 * @param {string} createId - 任务 ID
 * @returns {Promise<string>} 返回图片 URL
 */
export function queryRemoveBg(createId) {
  return apiClient
    .post('removeBgQuery', { create_id: createId }, {
      allowBizCodes: [220]
    })
    .then(function(res) {
      // 处理中：code 220，与直连图模型一致
      if (res && String(res.code || '') === '220') {
        return { status: 'processing' }
      }
      // 完成：code 200，拦截器已解包，res 即为 data
      var data = res.data || res
      var url = data.image || data.image_url || data.url || data.result_url || data.result
      if (url) {
        return { status: 'completed', url: url }
      }
      // 没有图片 URL，当作处理中继续轮询
      return { status: 'processing' }
    })
}

/**
 * 轮询移除背景结果，直到完成或失败
 * @param {string} createId - 任务 ID
 * @param {function} onProgress - 进度回调（可选）
 * @param {number} interval - 轮询间隔（毫秒），默认 3000
 * @param {number} timeout - 超时时间（毫秒），默认 600000（10分钟）
 * @returns {{ stop: function }} 返回可停止的轮询对象
 */
export function pollRemoveBgResult(createId, callback, interval, timeout) {
  var startTime = Date.now()
  var timer = null
  var stopped = false

  interval = interval || 3000
  timeout = timeout || 600000

  function poll() {
    if (stopped) return
    queryRemoveBg(createId).then(function(result) {
      if (stopped) return
      if (result.status === 'completed') {
        callback(null, result.url)
      } else if (result.status === 'failed') {
        callback(new Error(result.message || '移除背景处理失败'))
      } else {
        // 处理中，检查超时
        if (Date.now() - startTime > timeout) {
          callback(new Error('移除背景处理超时'))
          return
        }
        timer = setTimeout(poll, interval)
      }
    }).catch(function(err) {
      if (stopped) return
      // 查询失败，检查超时后重试
      if (Date.now() - startTime > timeout) {
        callback(err)
        return
      }
      timer = setTimeout(poll, interval)
    })
  }

  // 首次延迟后开始轮询
  timer = setTimeout(poll, interval)

  return {
    stop: function() {
      stopped = true
      if (timer) {
        clearTimeout(timer)
        timer = null
      }
    }
  }
}
